import { useState } from "react";
import AppNavbar from "../../../AppNavbar/AppNavbar";
import ProductDetails from "./ProductDetails";
import Reviews from "./Reviews";
import Dependencies from "./Dependencies";
import { CloudApp, GlobalApp } from "../../../../types/GlobalInterfaces";

const tabs = [
  {
    title: "Product Details",
    hidden: false,
    externalLink: "",
    activeValue: "product-details",
    disabled: false,
  },
  /*  {
    title: "Reviews",
    hidden: false,
    externalLink: "",
    activeValue: "reviews",
    disabled: false,
  }, */
  {
    title: "Dependencies",
    hidden: false,
    externalLink: "",
    activeValue: "dependencies",
    disabled: false,
  },
];

interface Props {
  app: CloudApp | GlobalApp;
}

const AppDetailTabs = ({ app }: Props) => {
  const [activeDetailTab, setActiveDetailTab] = useState("product-details");
  const activeKeySwitcher = () => {
    switch (activeDetailTab) {
      case "product-details":
        return <ProductDetails app={app} />;
      case "reviews":
        return <Reviews app={app} />;
      case "dependencies":
        return <Dependencies app={app} />;

      default:
        return <ProductDetails app={app} />;
    }
  };

  const handleSelect = (val: string) => {
    setActiveDetailTab(val);
  };

  return (
    <div className="mt-4">
      {/* @ts-ignore */}
      <AppNavbar
        tabs={tabs}
        activeTab={activeDetailTab}
        onSelect={(val: string) => handleSelect(val)}
      />
      <div className="w-100 h-100">{activeKeySwitcher()}</div>
    </div>
  );
};

export default AppDetailTabs;
